import { useMemo } from 'react'
import styled from 'styled-components'

import { DataTableHeaderCell } from '@root/shared/ui-kit/data-table'

import type { ExploreTableColumnId } from './explore-column'
import type { ExploreTableContext } from './explore-table-types'
import type { PairModel } from '@root/entities/pair/atoms'
import type { Column } from '@root/shared/ui-kit'
import type { ColumnHeaderRenderProps } from '@root/shared/ui-kit/data-table'

type Props = ColumnHeaderRenderProps<
  PairModel,
  ExploreTableColumnId,
  ExploreTableContext
> & {
  auxColumn: Column<PairModel, ExploreTableColumnId, ExploreTableContext>
}

export const ExploreTableDoubleColumnHeader: React.FC<Props> = ({
  auxColumn,
  column: mainColumn,
  ...props
}) => {
  const minWidth = 'minWidth' in mainColumn ? mainColumn.minWidth : undefined

  const sanitizedMainColumn = useMemo(() => {
    return {
      ...mainColumn,
      minWidth: undefined,
    }
  }, [mainColumn])

  return (
    <Root style={{ minWidth: minWidth }}>
      <DataTableHeaderCell {...props} column={sanitizedMainColumn} />
      <Separator>/</Separator>
      <DataTableHeaderCell {...props} column={auxColumn} />
    </Root>
  )
}

const Root = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-auto-columns: auto;
  justify-content: start;
  align-items: center;
  gap: 2px;
`

const Separator = styled.span`
  font-size: 11px;
  font-weight: 600;
  color: var(--text-9);
`
